import { render, staticRenderFns } from "./TabMulti.vue?vue&type=template&id=acd0fe4c&scoped=true&"
import script from "./TabMulti.vue?vue&type=script&lang=js&"
export * from "./TabMulti.vue?vue&type=script&lang=js&"
import style0 from "./TabMulti.vue?vue&type=style&index=0&id=acd0fe4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd0fe4c",
  null
  
)

export default component.exports